import gql from "graphql-tag";

const RiskProps = gql`
	fragment RiskProps on PatientRisk {
		id
		risk
		created_at
		author {
			id
			first_name
			surname
			middle_name
			email
			type {
				id
				name
			}
			designation {
				id
				name
			}
			image
		}
	}
`;

const LIST = gql`
	query GetRisks($patient: ID!) {
		GetPatientRisks(patient: $patient) {
			docs {
				...RiskProps
			}
			totalDocs
			totalPages
			page
			prevPage
			nextPage
			limit
		}
	}
	${RiskProps}
`;
const LIST_SMALL = gql`
	query GetRisksSmall($patient: ID!) {
		GetPatientRisks(patient: $patient, page: 1, limit: 20) {
			docs {
				id
				risk
			}
		}
	}
`;

const CREATE = gql`
	mutation NewRisk($model: RiskInput!) {
		RecordNewPatientRisk(model: $model) {
			message
			doc {
				...RiskProps
			}
		}
	}
	${RiskProps}
`;
export { LIST, CREATE, LIST_SMALL };
